import { SvgIcon, SvgIconProps } from '@mui/material';

export function PlusIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="u:plus">
          <path
            id="Vector"
            d="M14.25 8.25391H9.75V3.75391C9.75 3.55499 9.67098 3.36423 9.53033 3.22358C9.38968 3.08292 9.19891 3.00391 9 3.00391C8.80109 3.00391 8.61032 3.08292 8.46967 3.22358C8.32902 3.36423 8.25 3.55499 8.25 3.75391V8.25391H3.75C3.55109 8.25391 3.36032 8.33292 3.21967 8.47358C3.07902 8.61423 3 8.80499 3 9.00391C3 9.20282 3.07902 9.39358 3.21967 9.53424C3.36032 9.67489 3.55109 9.75391 3.75 9.75391H8.25V14.2539C8.25 14.4528 8.32902 14.6436 8.46967 14.7842C8.61032 14.9249 8.80109 15.0039 9 15.0039C9.19891 15.0039 9.38968 14.9249 9.53033 14.7842C9.67098 14.6436 9.75 14.4528 9.75 14.2539V9.75391H14.25C14.4489 9.75391 14.6397 9.67489 14.7803 9.53424C14.921 9.39358 15 9.20282 15 9.00391C15 8.80499 14.921 8.61423 14.7803 8.47358C14.6397 8.33292 14.4489 8.25391 14.25 8.25391Z"
            fill="currentcolor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
